import React from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import ReliabilitySaas from '../molecules/SaaSDevComponents/ReliabilitySaas'
import SaasIdeaProjects from '../molecules/SaaSDevComponents/SaasIdeaProjects'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import SaaSDevKeyFeatures from '../molecules/SaaSDevComponents/SaaSDevKeyFeatures'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import AppsMaintenance from '../molecules/AppsSupportComponents/AppsMaintenance/AppsMaintenance'
import { getPageData, useData } from '../../app/helper/functions'

const SaaSDevPage = () => {
    const { loading, data, error } = useData();
    const saasSoftwareData = getPageData(data, 'saasSoftwarePage');
    return (
        <div>
            <div className='bg-saasDevPage-bg bg-center bg-cover bg-no-repeat'>
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col justify-center items-center px-[10%] pb-8 gap-6 pt-52'>
                        <img src={images.ENTERPRISEHOMEIMAGE} className='z-10 w-[60%]' />
                        <div className='text-white flex flex-col gap-2 relative text-center justify-center items-center'>
                            <div className='font-bold text-6xl mb-2'>{saasSoftwareData.title}</div>
                            <div className='font-normal text-2xl'>{saasSoftwareData.description}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bg-darkGreyPrimary'>
                <Heading className='bg-darkGreyPrimary py-12'
                    title='BENEFITS'
                    subTitle='Why go for SaaS software development?'
                    text='SaaS (Software as a Service) offers a cloud solution that enables businesses to serve users anytime and
                    anywhere, eliminating the need for physical infrastructure. Custom SaaS solutions are ideal for
                    companies seeking rapid growth, cost reduction, and operational efficiency.' />
                <ReliabilitySaas saasSoftwareData={saasSoftwareData}/>
                <Heading className='bg-darkGreyPrimary py-12'
                    subTitle='Our approach to SaaS development'
                    text='We use a clear method for SaaS development that makes your platform scalable, safe, and ready for growth.
                    We stick to the best cloud development practices and aim to provide a great user experience.' />
                <SaasIdeaProjects saasSoftwareData={saasSoftwareData}/>
                <div className='pt-10 bg-darkGreyPrimary'>
                    <AppsRunning bgImage='bg-confident-saas-bg'
                        title='Key features of our SaaS solutions'
                        subtitle='Our SaaS platforms are built to grow and provide great value.
                        Here are some main features we usually create:' />
                </div>
                <SaaSDevKeyFeatures saasSoftwareData={saasSoftwareData}/>
                <ProjectDisplay />
                <AppsFaq />
                <AppsMaintenance bgImage='bg-maintenance-hospital-bg'
                    title='Get started on your SaaS development project today.'
                    subtitle='Want to create a scalable, cloud-based SaaS platform? Our skilled team is here to make your ideas come to life.' />
                <DefaultFooter />
            </div>

        </div>
    )
}

export default SaaSDevPage
